import { render, staticRenderFns } from "./MoneyStatement.vue?vue&type=template&id=27d421da&scoped=true&"
import script from "./MoneyStatement.vue?vue&type=script&lang=js&"
export * from "./MoneyStatement.vue?vue&type=script&lang=js&"
import style0 from "./MoneyStatement.vue?vue&type=style&index=0&id=27d421da&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27d421da",
  null
  
)

export default component.exports